<app-header sectionName="Dashboard" [showBackButton]="false">
  @if (proxyUsage && !proxyAlert) {
  <a class="proxy-chip" routerLink="/proxies"
    [matTooltip]="proxyUsage.gb_used + ' / ' + proxyUsage.gb_total + ' GB used (' + proxyUsage.plan + ')'">
    <mat-icon>dns</mat-icon>
    <span class="tabular">{{ proxyUsage.gb_remaining }} GB</span>
    <span class="proxy-chip-bar"><span [style.width.%]="100 - proxyUsage.percent_used"></span></span>
  </a>
  }
  <span class="user-chip">
    <mat-icon>account_circle</mat-icon>
    {{ username }}
  </span>
  <button mat-icon-button (click)="logout()" matTooltip="Log out">
    <mat-icon>logout</mat-icon>
  </button>
</app-header>

<div class="page">
  @if (proxyUsage && proxyAlert) {
  <a class="proxy-alert" routerLink="/proxies">
    <mat-icon>warning</mat-icon>
    <div class="proxy-alert-body">
      <strong>Proxy balance is low: {{ proxyUsage.gb_remaining }} GB left</strong>
      <span class="muted">{{ proxyUsage.gb_used }} / {{ proxyUsage.gb_total }} GB used on {{ proxyUsage.plan }}. Top up before it runs out.</span>
      <mat-progress-bar mode="determinate" color="warn" [value]="proxyUsage.percent_used"></mat-progress-bar>
    </div>
  </a>
  }

  @if (showContractBalance) {
  <app-contract-balance class="balance" variant="full"></app-contract-balance>
  }

  @for (section of sections; track section.title) {
  <section class="dash-section">
    <h2 class="section-title">
      <mat-icon>{{ section.icon }}</mat-icon>
      {{ section.title }}
    </h2>
    <div class="tile-grid">
      @for (link of section.links; track link.route) {
      <a class="tile" [routerLink]="link.route">
        <span class="tile-icon"><mat-icon>{{ link.icon }}</mat-icon></span>
        <span class="tile-text">
          <span class="tile-title">{{ link.title }}</span>
          <span class="tile-desc">{{ link.description }}</span>
        </span>
        <mat-icon class="tile-go">chevron_right</mat-icon>
      </a>
      }
    </div>
  </section>
  }
</div>
